import createIcon from '../../createIcon';

/**
 * @component @name DataSaverOn
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgNy45NzUzOVYxMC45NzU0SDhWMTIuOTc1NEgxMVYxNS45NzU0SDEzVjEyLjk3NTRIMTZWMTAuOTc1NEgxM1Y3Ljk3NTM5SDExWk0xMyAyLjAyNTM5VjUuMDU1MzlDMTYuMzkgNS41NDUzOSAxOSA4LjQ0NTM5IDE5IDExLjk3NTRDMTkgMTIuODc1NCAxOC44MiAxMy43MjU0IDE4LjUyIDE0LjUxNTRMMjEuMTIgMTYuMDQ1NEMyMS42OCAxNC44MDU0IDIyIDEzLjQyNTQgMjIgMTEuOTc1NEMyMiA2Ljc5NTM5IDE4LjA1IDIuNTI1MzkgMTMgMi4wMjUzOVpNMTIgMTguOTc1NEM4LjEzIDE4Ljk3NTQgNSAxNS44NDU0IDUgMTEuOTc1NEM1IDguNDQ1MzkgNy42MSA1LjU0NTM5IDExIDUuMDU1MzlWMi4wMjUzOUM1Ljk0IDIuNTI1MzkgMiA2Ljc4NTM5IDIgMTEuOTc1NEMyIDE3LjQ5NTQgNi40NyAyMS45NzU0IDExLjk5IDIxLjk3NTRDMTUuMyAyMS45NzU0IDE4LjIzIDIwLjM2NTQgMjAuMDUgMTcuODg1NEwxNy40NSAxNi4zNTU0QzE2LjE3IDE3Ljk1NTQgMTQuMjEgMTguOTc1NCAxMiAxOC45NzU0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DataSaverOn = createIcon('DataSaverOn', [
  [
    'path',
    {
      d: 'M11 7.97539V10.9754H8V12.9754H11V15.9754H13V12.9754H16V10.9754H13V7.97539H11ZM13 2.02539V5.05539C16.39 5.54539 19 8.44539 19 11.9754C19 12.8754 18.82 13.7254 18.52 14.5154L21.12 16.0454C21.68 14.8054 22 13.4254 22 11.9754C22 6.79539 18.05 2.52539 13 2.02539ZM12 18.9754C8.13 18.9754 5 15.8454 5 11.9754C5 8.44539 7.61 5.54539 11 5.05539V2.02539C5.94 2.52539 2 6.78539 2 11.9754C2 17.4954 6.47 21.9754 11.99 21.9754C15.3 21.9754 18.23 20.3654 20.05 17.8854L17.45 16.3554C16.17 17.9554 14.21 18.9754 12 18.9754Z',
      key: '51wqgt',
    },
  ],
]);

export default DataSaverOn;
